import { createActionTypes } from '../../../util/createLifeomicActionTypes';

export default createActionTypes([
  'TASKS_PAGE_SET_SEARCH',
  'TASKS_PAGE_TOGGLE_CREATE_DIALOG',
  'TASKS_PAGE_LIST_PUSH',
  'TASKS_PAGE_LIST_REPLACE',
]);
